/*
 * Public API Surface of channel-value
 */
export * from './channel-value.component';
export * from './channel-value.module';
